import { getDirectusClient } from '../lib/directus';
import { readItems, readUsers, updateItem } from '@directus/sdk';
import moment from 'moment';


export const getCircuitosByDay = async (dayId, userRoleID, userBodega) => {
 
  const directus = await getDirectusClient();
  try {
    const response = await directus.request(
      readItems('circuitos', {
        fields: [
          'id',
          'nombre',
          'descripcion',
          'tipo',
          'tiempo',
          'vendedor.id',
          'vendedor.first_name',
          'vendedor.last_name',
          'clientes.clientes_id.id'
        ],
        filter: {
          _and: [
            { dias: { dias_id: { id: { _eq: dayId } } } }
          ],
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
                bodega: {
                  id: { _eq: userBodega },
                },
              }
            : {}),
        }
      })
    );
    return response;
  } catch (error) {
    console.error('Error fetching circuitos:', error);
    throw error;
  }
};

export const getCircuitosByVendedor = async (vendedorId,  userRoleID, userBodega) => {
  const directus = await getDirectusClient();
  try {
    const response = await directus.request(
      readItems('circuitos', {
        fields: [
          'id',
          'nombre',
          'clientes.clientes_id.id',
          'clientes.clientes_id.first_name',
          'clientes.clientes_id.last_name'
        ],
        filter: {
          _and: [
            { vendedor: { id: { _eq: vendedorId } } }
          ],
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
                bodega: {
                  id: { _eq: userBodega },
                },
              }
            : {}),
        }
      })
    );
    return response;
  } catch (error) {
    console.error('Error fetching circuitos:', error);
    throw error;
  }
};

export const getEncuestas = async () => {
  const directus = await getDirectusClient();
  try {
    const response = await directus.request(
      readItems('encuestas', {
        fields: ['id', 'nombre']
      })
    );
    return response;
  } catch (error) {
    console.error('Error fetching encuestas:', error);
    throw error;
  }
};

export const getConteoRespuestasNoVerificadas = async (encuestaId, fecha) => {
  const directus = await getDirectusClient();
  try {
    const filter = {
      _and: [
        { verificada: { _eq: false } },
        { pregunta: { encuesta: { _eq: encuestaId } } }
      ]
    };

    if (fecha) {
      const startOfDay = moment(fecha).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const endOfDay = moment(fecha).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      filter._and.push({
        fecha: {
          _between: [startOfDay, endOfDay]
        }
      });
    }

    const response = await directus.request(
      readItems('respuestas', {
        filter,
        aggregate: {
          count: ['id']
        }
      })
    );
    return response[0]?.count?.id || 0;
  } catch (error) {
    console.error('Error fetching conteo respuestas:', error);
    throw error;
  }
};

export const getRespuestasEncuesta = async ({ fecha, vendedorId, clienteId, encuestaId, page = 1, limit = 25 }) => {
  const directus = await getDirectusClient();
  try {
    const filter = {
      verificada: { _eq: false }
    };

    if (clienteId) {
      filter.cliente = { id: { _eq: clienteId } };
    }
    if (encuestaId) {
      filter.pregunta = { encuesta: { _eq: encuestaId } };
    }

    // Obtener el total de registros
    const countResponse = await directus.request(
      readItems('respuestas', {
        filter,
        aggregate: {
          count: ['id']
        }
      })
    );
    const total = countResponse[0]?.count?.id || 0;

    // Obtener los registros paginados
    const response = await directus.request(
      readItems('respuestas', {
        fields: [
          'id',
          'texto',
          'numero',
          'unica',
          'multiples',
          'bodega.id',
          'cliente.id',
          'cliente.first_name',
          'cliente.last_name',
          'pregunta.id',
          'pregunta.pregunta',
          'verificada'
        ],
        filter,
        limit: limit,
        offset: (page - 1) * limit
      })
    );

    const data = response.map(item => ({
      id: item.id,
      cliente: item.cliente ? `${item.cliente.first_name} ${item.cliente.last_name}` : '',
      clienteId: item.cliente?.id,
      pregunta: item.pregunta?.pregunta || '',
      respuesta: item.texto || item.numero || item.unica || (item.multiples?.join(', ') || ''),
      verificada: item.verificada || false
    }));

    return { data, total };
  } catch (error) {
    console.error('Error fetching respuestas:', error);
    throw error;
  }
};

export const verificarRespuesta = async (respuestaId) => {
  const directus = await getDirectusClient();
  try {
    const response = await directus.request(
      updateItem('respuestas', respuestaId, {
        verificada: true
      })
    );
    return response;
  } catch (error) {
    console.error('Error verificando respuesta:', error);
    throw error;
  }
};

export const verificarRespuestasMasivo = async (respuestasIds) => {
  const directus = await getDirectusClient();
  try {
    const promises = respuestasIds.map(id => 
      directus.request(
        updateItem('respuestas', id, {
          verificada: true
        })
      )
    );
    await Promise.all(promises);
    return true;
  } catch (error) {
    console.error('Error verificando respuestas:', error);
    throw error;
  }
}; 